const document = (state = [], action) => {
    switch (action.type) {
        case "GET_DOCUMENT":
            return action.payload;
            break;
        default:
            return state;
            break;
    }
}

const documentTotalPage = (state = 0, action) => {
    switch (action.type) {
        case "GET_TOTAL_PAGE_DOCUMENT":
            return action.payload;
            break;
        default:
            return state;
            break;
    }
}

export { document, documentTotalPage } ;